import React from 'react';
import BaseField, { BaseFieldProps } from '../BaseField/BaseField';
import EducationMaterialMultiSelectWithCheckList from './EducationMaterialMultiSelectWithCheckList';

interface Props extends BaseFieldProps {
	isSearchable?: boolean;
	portal?: boolean;
}

const ECardFolderSelectField: React.FC<Props> = props => (
	<BaseField {...props}>
		<EducationMaterialMultiSelectWithCheckList
			portal={props.portal}
			isSearchable={props.isSearchable}
		/>
	</BaseField>
);

export default ECardFolderSelectField;
